import {
  AppointmentHistoryItem,
  AppointmentHistoryProposal,
} from '@airship-platform/service-history-feature/schema';
import { z } from 'zod';
import { AppointmentProposalOptionModifier } from '../appointmentProposalOptionModifiers';
import { AppointmentProposalOptionProduct } from '../appointmentProposalOptionProducts';
import { AppointmentProposalOption } from '../appointmentProposalOptions';
import { AppointmentProposal } from '../appointmentProposals';
import { Appointment } from '../appointments';

export const ProposalStatusSchema = z.enum([
  'PROPOSAL_CREATED',
  'PROPOSAL_NOT_SHARED',
  'PROPOSAL_SHARED',
  'PROPOSAL_ACCEPTED',
]);
export type ProposalStatusFilter = z.infer<typeof ProposalStatusSchema>;

export interface AppointmentHistoryFilter
  extends Record<string, string[] | string | number | boolean | undefined> {
  startDateTime?: string;
  endDateTime?: string;
  businessUnitIds?: string[];
  assignedUserIds: string[];
  status: AppointmentHistory['status'][];
  searchPeriod: string;
  pageSize: number;
  proposalStatus: ProposalStatusFilter[];
  searchTerm: string;
  includeNonAirshipJobs: boolean;
  sorting: 'DATE_ASC' | 'DATE_DESC';
}

export type AppointmentHistory = AppointmentHistoryItem;
export type { AppointmentHistoryProposal };

export interface AppointmentHistoryDetail {
  appointmentId: string;
  appointment: Pick<Appointment['appointment'], 'startDateTime'>;
  proposal: Pick<
    AppointmentProposal,
    'appointmentProposalId' | 'customerExperience'
  >;
  options: Pick<
    AppointmentProposalOption,
    'appointmentProposalOptionId' | 'status' | 'optionType' | 'name'
  >[];
  customer: Pick<Appointment['customer'], 'customerId' | 'name'>;
  location: Pick<
    Appointment['location'],
    'locationId' | 'address1' | 'address2' | 'city' | 'state' | 'zip'
  >;
  proposalProducts: (Pick<
    AppointmentProposalOptionProduct,
    | 'appointmentProposalOptionProductId'
    | 'appointmentProposalOptionId'
    | 'name'
    | 'quantity'
    | 'price'
    | 'type'
    | 'description'
    | 'model'
    | 'brand'
    | 'pricebookId'
    | 'currency'
    | 'taxable'
    | 'equipmentTypeIds'
    | 'images'
    | 'warranties'
    | 'groupingName'
    | 'categoryIds'
  > & {
    defaultPriceType?: AppointmentProposalOptionProduct['defaultPriceType'];
    linkedItems?: AppointmentProposalOptionProduct['linkedItems'];
    pricebookPrices?: AppointmentProposalOptionProduct['pricebookPrices'];
  })[];
  proposalModifiers: Pick<
    AppointmentProposalOptionModifier,
    | 'appointmentProposalOptionModifierId'
    | 'appointmentProposalOptionId'
    | 'description'
    | 'amount'
    | 'amountType'
    | 'limit'
    | 'taxable'
    | 'categoryIds'
    | 'displayName'
    | 'status'
    | 'modifierType'
    | 'roundingRule'
    | 'taxBasis'
    | 'discountsAndFeesId'
    | 'images'
    | 'qualifyingPricebookCategoryIds'
    | 'qualifyingPricebookIds'
  >[];
}
